// PARAQTA — «Жетістіктер» беті (профильдегі «Барлығы →»).
//
// 04.10.26: ЖАЛҒЫЗ ДЕРЕККӨЗ — backend `/api/profile/me` → `achievements`
// (main.py ACHIEVEMENT_DEFS). Бұрын бұл бет frontend-тегі бөлек 16-лық тізімді
// window._dashData-мен тексеретін; ол айнымалы өлі «Бүгін» бетімен бірге
// толмай қалғандықтан, кітап/стрик/клуб жетістіктері бәріне құлыпталған
// болып көрінетін. Енді профиль мен осы бет бір санды көрсетеді.

import { api } from '../../core/api.js';
import { esc } from '../../utils/format.js';

export async function renderAchievements() {
  const grid = document.getElementById('achGrid');
  if (!grid) return;
  grid.innerHTML = '<div class="loading"><span class="spinner"></span>Жүктелуде...</div>';
  let a = null;
  try {
    const d = await api('/api/profile/me');
    a = d && d.achievements;
  } catch (_) { a = null; }
  const list = (a && Array.isArray(a.list)) ? a.list : null;
  if (!list) {
    grid.innerHTML = '<div class="empty-state"><p>Жетістіктер ашылмады.<br>Қайта кіріп көр.</p></div>';
    return;
  }
  // Мереке (жаңа ашылған жетістік) — сол дерекпен.
  import('../celebrations/index.js').then(m => m.maybeCelebrateAchievements(list)).catch(() => {});

  const earned = list.filter(x => x.earned).length;
  grid.innerHTML =
    '<div style="grid-column:1/-1;margin-bottom:4px;font-size:.82rem;color:var(--ink3)">' +
      earned + ' / ' + list.length + ' жетістік ашылды</div>' +
    list.map(x =>
      '<div class="ach-card ' + (x.earned ? '' : 'locked') + '"><div class="ach-icon">' + esc(x.icon || '') + '</div>' +
      '<div class="ach-name">' + esc(x.title || '') + '</div><div class="ach-desc">' + esc(x.subtitle || '') + '</div></div>'
    ).join('');
}
